import classNames from 'classnames'

export interface TimestampProps
  extends React.ComponentPropsWithoutRef<'span'> {}

export const Timestamp = ({
  children,
  className,
  ...props
}: TimestampProps) => {
  return (
    <span
      className={classNames('content-teaser__timestamp', className)}
      {...props}
    >
      {children}
    </span>
  )
}
